/**
 * Get alert category for alert modal content
 * @return null || modal
 */

 const getSelectedAlertData = state => state.modal.selectedAlertData;

 export default getSelectedAlertData;